import { Dispatch } from '../../../../../types/actions';
import { ISnackbarModel } from '../../store/types';
import { snackbarInfoDefault } from './infoDefault';

export const snackbarCardInfoDefault = (
    options: ISnackbarModel
) => {
    return (dispatch: Dispatch) => {
        if (options.icon === undefined) {
            options.icon = 'card';
        }
        dispatch(snackbarInfoDefault(options));
    }
};
